import type React from 'react';

import { Image } from '@change/ds-core-ui/Image';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export const PhotoMobile: React.FC<Props> = ({ id, url, mobileUrl }) => {
	return (
		<div className="relative w-full">
			<Image aspectRatio="16:9" id={id} src={mobileUrl || url} alt="" className="w-full align-top" />
		</div>
	);
};
